// DEBUG: Script loaded
console.log('[BNZ Product Page] Script bnz-product-page.js loaded');

// Wait for Swiper to be loaded
function waitForSwiper(callback) {
  if (typeof Swiper !== 'undefined') {
    callback();
  } else {
    setTimeout(function() {
      waitForSwiper(callback);
    }, 100);
  }
}

// Submit all forms functionality
$(document).ready(function(){
    console.log('[BNZ Product Page] jQuery ready fired');
    $('#submitAll').click(function(e) {
      e.preventDefault();
      $('.main-product-detail-buy').each(function() {
        $.ajax({
          type: $(this).attr('method'),
          url: $(this).attr('action'),
          data: $(this).serialize(),
                success: function(response) {
          // Form submitted successfully
        },
        error: function(err) {
          // Error in form submission
        }
        });
      });
    });
  
    // Initialize product page functionality - Wait for Swiper
    waitForSwiper(function() {
      // The original theme's product.js loads on every product page and grabs the theme's
      // reserved IDs #main-slider / #thumbnail-slider — and it inits #main-slider TWICE, so
      // `el.swiper` only points at the 2nd instance; the 1st is orphaned with live touch
      // listeners we can't reach. When it forwarded setTransition to the thumbnail Swiper we
      // had destroyed, it threw `Cannot read properties of undefined (reading 'cssMode')` on
      // every touchmove, aborting the swipe ("le slider ne slide plus"). Fix: bnz's gallery
      // now uses its OWN IDs (#bnz-main-slider / #bnz-thumbnail-slider), so product.js finds
      // nothing and never touches our gallery. The destroy loop below is kept as cheap
      // defense in case anything else ever initializes these elements.
      ['#bnz-main-slider', '#bnz-thumbnail-slider'].forEach(function(sel) {
        const existingEl = document.querySelector(sel);
        if (existingEl && existingEl.swiper) {
          try { existingEl.swiper.destroy(true, true); } catch (e) { /* no-op */ }
        }
      });

      // Initialize product slider
      // cssMode on mobile: Swiper hardcodes its touchmove listener as NON-passive (so it can
      // preventDefault for horizontal swipes). Once `touchAngle` locks the gesture into
      // "horizontal" on the first ~5px of movement, vertical PAGE scroll gets trapped — no
      // amount of `touch-action: pan-y` CSS can override a preventDefault that's already fired.
      // cssMode bypasses JS touch handling entirely: the swiper-wrapper becomes a native
      // horizontal scroll-snap container, the browser handles touch, and vertical scroll on
      // the parent page is never blocked. Desktop keeps the JS Swiper for the thumbnail link.
      const isMobile = window.innerWidth <= 768;
      const mainSlider = new Swiper('#bnz-main-slider', {
      cssMode: isMobile,
      // Mobile peek configured HERE at init (not mutated after) so cssMode builds its native
      // scroll-snap grid from the right slide widths. 1.176 = 1/0.85 → each slide ≈ 85% of the
      // viewport, next slide peeks ~15%. Desktop keeps 1 / 0.
      slidesPerView: isMobile ? 1.176 : 1,
      spaceBetween: isMobile ? 12 : 0,
      centeredSlides: false,
      preventInteractionOnTransition: false,
      simulateTouch: true,
      allowTouchMove: true,
      touchRatio: 1,
      touchStartPreventDefault: false, // Don't block touchstart so vertical page scroll over the gallery is possible on mobile
      passiveListeners: true, // Passive touch listeners: Swiper can't preventDefault, so it never traps the page's vertical scroll on mobile
      touchEventsTarget: 'wrapper', // Only respond to touches on the wrapper, not container
      touchAngle: 30, // Only respond to horizontal swipes (30 degrees from horizontal)
      // Prevent vertical drags from triggering the main slider
      on: {
        touchStart: function(swiper, event) {
          // Check if touch is in thumbnail area
          const thumbnailContainer = document.querySelector('.thumbnail-slider--container');
          if (thumbnailContainer && event.target && thumbnailContainer.contains(event.target)) {
            return false; // Don't handle this touch
          }
        }
      },
      // Reduce the distance needed for slide changes
      slidesPerGroup: 1,
      slidesPerGroupSkip: 0,
      // Improve swipe behavior
      watchSlidesProgress: true,
      watchOverflow: true,
      navigation: {
        nextEl: '.swiper-button-nexts',
        prevEl: '.swiper-button-prevs',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      touchAngle: 30,
      // Touch sensitivity settings for better mobile responsiveness
      threshold: 0, // No threshold for immediate response
      touchRatio: 1.5, // More sensitive touch movement
      resistanceRatio: 0, // No resistance for natural sliding
      longSwipesRatio: 0.05, // Only 5% of slide width required to change slide
      longSwipesMs: 100, // Faster long swipe detection
      // Momentum and swipe behavior
      followFinger: true,
      allowTouchMove: true,
      shortSwipes: true,
      longSwipes: true,
      // Reduce the distance needed for slide change
      slidesPerGroup: 1,
      slidesPerGroupSkip: 0,
      shortSwipes: true,
      longSwipes: true,
      followFinger: true,
      allowTouchMove: true,
      breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 0,
          centeredSlides: false,
          threshold: 0, // No threshold on mobile for immediate response
          touchRatio: 1.5, // More sensitive touch movement on mobile
          resistanceRatio: 0, // No resistance on mobile for natural sliding
          longSwipesRatio: 0.05, // Only 5% of slide width required on mobile
          longSwipesMs: 100, // Faster detection on mobile
        },
        1024: {
          allowTouchMove: false,
          simulateTouch: false
        }
      },
      on: {
        init: function() {
          const isDesktop = window.innerWidth >= 1024;
          this.allowTouchMove = !isDesktop;
          this.params.simulateTouch = !isDesktop;
        },
        resize: function() {
          const isDesktop = window.innerWidth >= 1024;
          this.allowTouchMove = !isDesktop;
          this.params.simulateTouch = !isDesktop;
        }
      }
    });
  
    // NOTE: mobile peek (slidesPerView 1.176 / spaceBetween 12) is set at init above, NOT
    // mutated here. The previous post-init block broke sliding on mobile in two ways:
    //   1. `mainSlider.update()` in cssMode can reset the native scroll-snap grid.
    //   2. `allowTouchMove = false` was set "to let the browser own the gesture" — but in
    //      cssMode the browser's native scroll is exactly what MOVES the slides, so killing
    //      Swiper's touch path left the wrapper non-swipeable. cssMode + passiveListeners
    //      already guarantees Swiper never preventDefaults vertical scroll, so there is
    //      nothing to disable. Leave allowTouchMove at its default.

    // Swiper 11 (loaded from cdn.jsdelivr.net/swiper@11) auto-attaches the Thumbs and
    // Controller modules to every new instance. They register `setTransition` listeners
    // that forward the call to `swiper.thumbs.swiper` / `swiper.controller.control`.
    // If those still point at a Swiper we just destroyed (product.js had configured
    // #main-slider with `thumbs: { swiper: '#bnz-thumbnail-slider' }`, and we destroy both
    // at startup), the forwarded `setTransition` crashes inside its target with
    // `Cannot read properties of undefined (reading 'cssMode')` — destroy() zaps params.
    // Symptom: touchmove on #main-slider throws, swipe is dead. Dots still work because
    // `slideTo()` doesn't route through the same listener chain. Cleared explicitly.
    if (mainSlider.thumbs) mainSlider.thumbs.swiper = null;
    if (mainSlider.controller) mainSlider.controller.control = null;

    // Desktop thumbnail strip: a plain vertical Swiper, free scroll by drag, native up/down
    // navigation. A previous version stacked custom click handlers on top of the native
    // navigation (each arrow click moved two slides), re-clamped the translate from inside the
    // setTranslate event, ran rAF + 16ms/100ms loops forever and disabled the main slider on
    // every mousedown in the strip. All of that fought Swiper and made the strip jumpy.
    // The strip is a sibling of #bnz-main-slider, so its drags never reach the main slider.
    const thumbnailSliderEl = document.querySelector('#bnz-thumbnail-slider');
    let thumbSlider = null;

    if (thumbnailSliderEl && window.innerWidth > 768) {
      thumbSlider = new Swiper('#bnz-thumbnail-slider', {
        direction: 'vertical',
        slidesPerView: 'auto',
        spaceBetween: 10,
        freeMode: {
          enabled: true,
          sticky: false,
          momentumBounce: false,
        },
        resistanceRatio: 0,
        watchSlidesProgress: true,
        watchOverflow: true,
        grabCursor: true,
        // Mousewheel stays off: it traps the wheel over the strip and blocks the page scroll.
        mousewheel: {
          enabled: false,
        },
        navigation: {
          nextEl: '.thumbnail-slider--container .thumbnail-nav-next',
          prevEl: '.thumbnail-slider--container .thumbnail-nav-prev',
        },
      });

      // Thumbnails are lazy images: re-measure once each one lands, otherwise Swiper keeps
      // the slide sizes read before load and the scroll bounds are off.
      thumbnailSliderEl.querySelectorAll('img').forEach(function(img) {
        if (!img.complete) {
          img.addEventListener('load', function() { thumbSlider.update(); }, { once: true });
        }
      });
    }

    // Link the sliders and handle thumbnail clicks
    if (mainSlider.slides.length > 0) {
      let isClickingThumbnail = false;
      
      // Update active thumbnail on main slider change
      mainSlider.on('slideChange', function() {
        updateActiveThumbnail(mainSlider.activeIndex);
        
        // Only auto-scroll thumbnails if we're NOT clicking a thumbnail
        // This prevents the jarring scroll-to-top effect when clicking thumbnails
        if (thumbSlider && !isClickingThumbnail) {
          thumbSlider.slideTo(mainSlider.activeIndex);
        }
      });
      
      // Update main slider when thumbnail is clicked
      const thumbnailButtons = document.querySelectorAll('.thumbnail-button');
      thumbnailButtons.forEach((button, index) => {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          // Set flag to prevent thumbnail auto-scroll
          isClickingThumbnail = true;
          mainSlider.slideTo(index);
          // Reset flag after a short delay
          setTimeout(() => {
            isClickingThumbnail = false;
          }, 100);
        });
      });
      
      // Function to update active thumbnail
      function updateActiveThumbnail(activeIndex) {
        thumbnailButtons.forEach((button, index) => {
          if (index === activeIndex) {
            button.classList.add('active');
          } else {
            button.classList.remove('active');
          }
        });
      }
      
      // Initialize active thumbnail
      updateActiveThumbnail(0);

      // No Controller link to thumbSlider: the slideChange handler above already scrolls the
      // strip, and having both drive it at once made the thumbnails jump between positions.
    }
    }); // End of waitForSwiper callback
  }); // End of $(document).ready
  
  // Currency message functionality
  document.addEventListener('DOMContentLoaded', function() {
    var addToCartButton = document.querySelector('#AddToCart');
  
    if (addToCartButton && addToCartButton.textContent.includes('CHF')) {
      var messageContainer = document.getElementById('currency-message-container');
      if (messageContainer) {
        messageContainer.innerHTML = '<p class="currency-message">Pas de frais de douane.</p>';
      }
    }
  });
  
  
  
  // Comprehensive variant handling for main product page
  // Wait for jQuery and DOM to be ready
  function initVariantHandlers() {
    // Check if jQuery is available
    if (typeof jQuery === 'undefined') {
      setTimeout(initVariantHandlers, 50);
      return;
    }
    
    // Use jQuery ready or DOMContentLoaded fallback
    if (jQuery && jQuery.ready) {
      jQuery(document).ready(function() {
        setupVariantHandlers();
      });
    } else {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setupVariantHandlers);
      } else {
        setupVariantHandlers();
      }
    }
  }
  
  function setupVariantHandlers() {
    var productId = window.productId || 0; // Will be set by Liquid template
    
    // Only run for non-sample products
    if (productId !== 87191644409230000000000) {
      
      // Get the selected variant ID
      var variants = window.productVariants || [];
      if (variants.length > 0) {
        var selectedVariant = null;
        var SelectedVariantSize, SelectedVariantPerfume, SelectedVariantColor, SelectedVariantPrice, SelectedVariantSample;
        
        // Check for different variant types
        var selectedSizeElement = $('.product-variant__select-container[data-type="Montants"] select');
        var sizeValue = selectedSizeElement.length > 0 && selectedSizeElement.val() ? selectedSizeElement.val() : null;
  
        var selectedPriceElement = $('.product-variant__select-container[data-type="Protocoles Anti-chute"] select');
        var priceValue = selectedPriceElement.length > 0 && selectedPriceElement.val() ? selectedPriceElement.val() : null;
  
        var selectedPerfumeElement = $('.product-variant__select-container[data-type="Parfum"] select');
        var perfumeValue = selectedPerfumeElement.length > 0 && selectedPerfumeElement.val() ? selectedPerfumeElement.val() : null;
  
        var selectedColorElement = $('.product-variant__select-container[data-type="Coloris"] select');
        var colorValue = selectedColorElement.length > 0 && selectedColorElement.val() ? selectedColorElement.val() : null;
  
        var selectedSampleElement = $('.product-variant__select-container[data-type="Choisissez vos échantillons"] input[type=radio]:checked');
        var sampleValue = selectedSampleElement.length > 0 && selectedSampleElement.val() ? selectedSampleElement.val() : null;
  
        // Don't update price on page load - only when user makes a selection
        var userHasInteracted = false;
        
        // Helper function to update price dynamically
        function updatePriceForVariant(variant) {
          if (!variant) return;
          
          var priceInCents = variant.price;
          var comparePriceInCents = variant.compare_at_price || 0;
          var priceInCurrency = priceInCents / 100;
          // Get current shop currency from Shopify
          var currentCurrency = window.Shopify?.currency?.active || 'EUR';
          var locale = currentCurrency === 'CHF' ? 'de-CH' : 'fr-FR';
          var formattedPrice = priceInCurrency.toLocaleString(locale, {
            style: 'currency',
            currency: currentCurrency
          });
          
          // Update all dynamic price elements
          $('#dynamic-price').text(formattedPrice);
          $('#AddToCart #dynamic-price').text(formattedPrice);
          // Do not update add-cart block price when variant is sold out (keeps "Épuisé" state)
          if (variant.available) {
            $('.main-product-detail--add-cart #dynamic-price').text(formattedPrice);
          }

          // Show/hide compare price
          if (comparePriceInCents > priceInCents) {
            var comparePriceInCurrency = comparePriceInCents / 100;
            var formattedComparePrice = comparePriceInCurrency.toLocaleString(locale, {
              style: 'currency',
              currency: currentCurrency
            });
            $('.compare').html(formattedComparePrice).show();
          } else {
            $('.compare').hide();
          }
        }
        
        // Helper function to update add to cart button state based on variant availability
        function updateAddToCartButton(variant) {
          if (!variant) return;
          
          var isAvailable = variant.available || false;
          var productId = window.productId || 0;
          var continueSellActive = $('.continue-sell-message').length > 0;
          
          // Get all add to cart buttons (desktop and mobile)
          var addToCartButtons = document.querySelectorAll('#AddToCart');
          
          addToCartButtons.forEach(function(button) {
            // Update disabled state
            // Don't disable if product ID is 8719164440923 or continue sell is active
            if (isAvailable || productId == 8719164440923 || continueSellActive) {
              button.removeAttribute('disabled');
            } else {
              button.setAttribute('disabled', 'disabled');
            }
            
            // Update visibility of add to cart / sold out spans
            // Find spans within this button - querySelector should work within button context
            var addSpan = button.querySelector('span#add-to-cart__information-add');
            var outSpan = button.querySelector('span#add-to-cart__information-out');
            
            // Fallback: if IDs don't work (duplicated), find by class and position
            if (!addSpan || !outSpan) {
              var allSpans = button.querySelectorAll('span.add-to-cart__information');
              if (allSpans.length >= 2) {
                // First span is usually "add", second is "out"
                addSpan = allSpans[0];
                outSpan = allSpans[1];
              }
            }
            
            if (addSpan && outSpan) {
              if (isAvailable || continueSellActive) {
                addSpan.classList.remove('hidden');
                outSpan.classList.add('hidden');
              } else {
                addSpan.classList.add('hidden');
                outSpan.classList.remove('hidden');
              }
            }
          });
        }
  
                // Handle Montants (size/price) variants
          if (sizeValue !== null) {
          $('.product-variant__select').on('change', function() {
            userHasInteracted = true; // Mark that user has interacted
            
            // Get all currently selected options from all dropdowns
            var selectedOptions = {};
            $('.product-variant__select').each(function() {
              var type = $(this).closest('.product-variant__select-container').data('type');
              if (type) {
                selectedOptions[type] = $(this).val();
              }
            });
            
            // Try to find variant by matching all options first
            SelectedVariantSize = null;
            for (var i = 0; i < variants.length; i++) {
              var variant = variants[i];
              var matches = true;
              
              for (var optionType in selectedOptions) {
                var optionValue = selectedOptions[optionType];
                if (optionValue) {
                  var normalizedValue = optionValue.replace('€', '').trim();
                  var normalizedOption1 = (variant.option1 || '').replace('€', '').trim();
                  var normalizedOption2 = (variant.option2 || '').replace('€', '').trim();
                  var normalizedOption3 = (variant.option3 || '').replace('€', '').trim();
                  
                  if (normalizedOption1 !== normalizedValue && 
                      normalizedOption2 !== normalizedValue && 
                      normalizedOption3 !== normalizedValue) {
                    matches = false;
                    break;
                  }
                }
              }
              
              if (matches) {
                SelectedVariantSize = variant;
                break;
              }
            }
            
            // Fallback: if no match found, try matching by single option (Montants)
            if (!SelectedVariantSize && selectedSizeElement.length) {
              var selectedSize = selectedSizeElement.val();
              if (selectedSize) {
                selectedSize = selectedSize.replace('€', '').trim();
                for (var i = 0; i < variants.length; i++) {
                  var variant = variants[i];
                  var option1 = (variant.option1 || '').replace('€', '').trim();
                  
                  if (option1 == selectedSize) {
                    SelectedVariantSize = variant;
                    break;
                  }
                }
              }
            }
            
            if (SelectedVariantSize != null) {
              $('#variant-selected').val(SelectedVariantSize.id);
              $('#variant-id').val(SelectedVariantSize.id);
              $('.main-product-detail-buy input[name="id"]').val(SelectedVariantSize.id);
  
              // Only update price if user has interacted
              if (userHasInteracted) {
                updatePriceForVariant(SelectedVariantSize);
                updateAddToCartButton(SelectedVariantSize);
              }
            } else {
              // No variant selected
            }
          });
        }
  
                // Handle Parfum variants
          else if (perfumeValue !== null) {
          $('.product-variant__select').on('change', function() {
            userHasInteracted = true;
            
            // Get all currently selected options from all dropdowns
            var selectedOptions = {};
            $('.product-variant__select').each(function() {
              var type = $(this).closest('.product-variant__select-container').data('type');
              if (type && $(this).val()) {
                selectedOptions[type] = $(this).val();
              }
            });
            
            // Try to find variant by matching all options first
            SelectedVariantPerfume = null;
            for (var i = 0; i < variants.length; i++) {
              var variant = variants[i];
              var matches = true;
              
              for (var optionType in selectedOptions) {
                var optionValue = selectedOptions[optionType];
                if (optionValue) {
                  var normalizedValue = optionValue.replace('€', '').trim();
                  var normalizedOption1 = (variant.option1 || '').replace('€', '').trim();
                  var normalizedOption2 = (variant.option2 || '').replace('€', '').trim();
                  var normalizedOption3 = (variant.option3 || '').replace('€', '').trim();
                  
                  if (normalizedOption1 !== normalizedValue && 
                      normalizedOption2 !== normalizedValue && 
                      normalizedOption3 !== normalizedValue) {
                    matches = false;
                    break;
                  }
                }
              }
              
              if (matches && Object.keys(selectedOptions).length > 0) {
                SelectedVariantPerfume = variant;
                break;
              }
            }
            
            // Fallback: if no match found, try matching by single option (Parfum)
            if (!SelectedVariantPerfume && selectedPerfumeElement.length) {
              var selectedPerfume = selectedPerfumeElement.val();
              if (selectedPerfume) {
                selectedPerfume = selectedPerfume.replace('€', '').trim();
                for (var i = 0; i < variants.length; i++) {
                  var variant = variants[i];
                  var option1 = (variant.option1 || '').replace('€', '').trim();
                  
                  if (option1 == selectedPerfume) {
                    SelectedVariantPerfume = variant;
                    break;
                  }
                }
              }
            }
            
            if (SelectedVariantPerfume != null) {
              $('#variant-selected').val(SelectedVariantPerfume.id);
              $('#variant-id').val(SelectedVariantPerfume.id);
              $('.main-product-detail-buy input[name="id"]').val(SelectedVariantPerfume.id);
              
              // Update price dynamically
              if (userHasInteracted) {
                updatePriceForVariant(SelectedVariantPerfume);
                updateAddToCartButton(SelectedVariantPerfume);
              }
            } else {
              // No variant Perfume selected
            }
          });
        }
  
                // Handle Coloris variants
          else if (colorValue !== null) {
          $('.product-variant__select').on('change', function() {
            userHasInteracted = true;
            
            // Get all currently selected options from all dropdowns
            var selectedOptions = {};
            $('.product-variant__select').each(function() {
              var type = $(this).closest('.product-variant__select-container').data('type');
              if (type && $(this).val()) {
                selectedOptions[type] = $(this).val();
              }
            });
            
            // Try to find variant by matching all options first
            SelectedVariantColor = null;
            for (var i = 0; i < variants.length; i++) {
              var variant = variants[i];
              var matches = true;
              
              for (var optionType in selectedOptions) {
                var optionValue = selectedOptions[optionType];
                if (optionValue) {
                  var normalizedValue = optionValue.replace('€', '').trim();
                  var normalizedOption1 = (variant.option1 || '').replace('€', '').trim();
                  var normalizedOption2 = (variant.option2 || '').replace('€', '').trim();
                  var normalizedOption3 = (variant.option3 || '').replace('€', '').trim();
                  
                  if (normalizedOption1 !== normalizedValue && 
                      normalizedOption2 !== normalizedValue && 
                      normalizedOption3 !== normalizedValue) {
                    matches = false;
                    break;
                  }
                }
              }
              
              if (matches && Object.keys(selectedOptions).length > 0) {
                SelectedVariantColor = variant;
                break;
              }
            }
            
            // Fallback: if no match found, try matching by single option (Coloris)
            if (!SelectedVariantColor && selectedColorElement.length) {
              var selectedColor = selectedColorElement.val();
              if (selectedColor) {
                selectedColor = selectedColor.replace('€', '').trim();
                for (var i = 0; i < variants.length; i++) {
                  var variant = variants[i];
                  var option1 = (variant.option1 || '').replace('€', '').trim();
                  
                  if (option1 == selectedColor) {
                    SelectedVariantColor = variant;
                    break;
                  }
                }
              }
            }
            
            if (SelectedVariantColor != null) {
              $('#variant-selected').val(SelectedVariantColor.id);
              $('#variant-id').val(SelectedVariantColor.id);
              $('.main-product-detail-buy input[name="id"]').val(SelectedVariantColor.id);
              
              // Update price dynamically
              if (userHasInteracted) {
                updatePriceForVariant(SelectedVariantColor);
                updateAddToCartButton(SelectedVariantColor);
              }
            } else {
              // No variant Color selected
            }
          });
        }
  
                // Handle Protocoles variants
          else if (priceValue !== null) {
          $('.compare').hide();
          
          $('.product-variant__select').on('change', function() {
            userHasInteracted = true;
            
            // Get all currently selected options from all dropdowns
            var selectedOptions = {};
            $('.product-variant__select').each(function() {
              var type = $(this).closest('.product-variant__select-container').data('type');
              if (type && $(this).val()) {
                selectedOptions[type] = $(this).val();
              }
            });
            
            // Try to find variant by matching all options first
            SelectedVariantPrice = null;
            for (var i = 0; i < variants.length; i++) {
              var variant = variants[i];
              var matches = true;
              
              for (var optionType in selectedOptions) {
                var optionValue = selectedOptions[optionType];
                if (optionValue) {
                  var normalizedValue = optionValue.replace('€', '').trim();
                  var normalizedOption1 = (variant.option1 || '').replace('€', '').trim();
                  var normalizedOption2 = (variant.option2 || '').replace('€', '').trim();
                  var normalizedOption3 = (variant.option3 || '').replace('€', '').trim();
                  
                  if (normalizedOption1 !== normalizedValue && 
                      normalizedOption2 !== normalizedValue && 
                      normalizedOption3 !== normalizedValue) {
                    matches = false;
                    break;
                  }
                }
              }
              
              if (matches && Object.keys(selectedOptions).length > 0) {
                SelectedVariantPrice = variant;
                break;
              }
            }
            
            // Fallback: if no match found, try matching by single option (Protocoles)
            if (!SelectedVariantPrice && selectedPriceElement.length) {
              var selectedPrice = selectedPriceElement.val();
              if (selectedPrice) {
                selectedPrice = selectedPrice.replace('€', '').trim();
                for (var i = 0; i < variants.length; i++) {
                  var variant = variants[i];
                  var option1 = (variant.option1 || '').replace('€', '').trim();
                  
                  if (option1 == selectedPrice) {
                    SelectedVariantPrice = variant;
                    break;
                  }
                }
              }
            }
  
            if (SelectedVariantPrice != null) {
              $('#variant-selected').val(SelectedVariantPrice.id);
              $('#variant-id').val(SelectedVariantPrice.id);
              $('.main-product-detail-buy input[name="id"]').val(SelectedVariantPrice.id);
  
              // Only update price if user has interacted
              if (userHasInteracted) {
                updatePriceForVariant(SelectedVariantPrice);
                updateAddToCartButton(SelectedVariantPrice);
              }
            } else {
              // No variant protocole selected
            }
          });
        }
  
                // Handle Sample variants with radio buttons
          else if (sampleValue !== null) {
          $('input[type=radio][name="product-variant"]').on('change', function() {
            userHasInteracted = true;
            var selectedRadio = $(this);
            var selectedSample = selectedRadio.val();
            var selectedVariantId = selectedRadio.data('variant-id');
            var SelectedVariantSample = null;
  
            // Try to find variant by ID first (most reliable)
            if (selectedVariantId) {
              for (var i = 0; i < variants.length; i++) {
                if (variants[i].id == selectedVariantId) {
                  SelectedVariantSample = variants[i];
                  break;
                }
              }
            }
            
            // Fallback: find by option value
            if (!SelectedVariantSample) {
              for (var i = 0; i < variants.length; i++) {
                var variant = variants[i];
                var option1 = variant.option1.replace('€', '').trim();
  
                if (option1 == selectedSample) {
                  SelectedVariantSample = variant;
                }
              }
            }
            
            if (SelectedVariantSample != null) {
              $('#variant-selected').val(SelectedVariantSample.id);
              $('#variant-id').val(SelectedVariantSample.id);
              $('.main-product-detail-buy input[name="id"]').val(SelectedVariantSample.id);
              
              // Update selected image
              var imageUrl = selectedRadio.data('image');
              if (imageUrl) {
                $('#selected-image').html('<img src="' + imageUrl + '" alt="' + SelectedVariantSample.title + '">');
              }
              
              // Update price dynamically
              if (userHasInteracted) {
                updatePriceForVariant(SelectedVariantSample);
                updateAddToCartButton(SelectedVariantSample);
              }
            } else {
              // No variant Sample selected
            }
          });
        }
        
        // Handle variant radio buttons for banzdodownechant (general case)
        // This handles cases where dropdown_to_buttons metafield is active
        if ($('.product-variant__radio').length > 0) {
          $('.product-variant__radio').on('change', function() {
            userHasInteracted = true;
            var selectedRadio = $(this);
            var selectedVariantId = selectedRadio.data('variant-id');
            var SelectedVariant = null;
            
            // Find the variant by ID (most reliable)
            for (var i = 0; i < variants.length; i++) {
              if (variants[i].id == selectedVariantId) {
                SelectedVariant = variants[i];
                break;
              }
            }
            
            // Fallback: if variant ID not found, try matching by option values
            if (!SelectedVariant) {
              var selectedValue = selectedRadio.val();
              for (var i = 0; i < variants.length; i++) {
                var variant = variants[i];
                if (variant.option1 == selectedValue || 
                    variant.option2 == selectedValue || 
                    variant.option3 == selectedValue) {
                  SelectedVariant = variant;
                  break;
                }
              }
            }
            
            if (SelectedVariant) {
              $('#variant-selected').val(SelectedVariant.id);
              $('#variant-id').val(SelectedVariant.id);
              $('.main-product-detail-buy input[name="id"]').val(SelectedVariant.id);
              
              // Update price dynamically
              if (userHasInteracted) {
                updatePriceForVariant(SelectedVariant);
                updateAddToCartButton(SelectedVariant);
              }
            }
          });
        }
        
        // Universal handler for all dropdown selects
        // This is the PRIMARY handler that works for ALL variant types
        var generalSelectHandler = function() {
          // Get all currently selected options from all selects
          var selectedOptions = {};
          $('.product-variant__select').each(function() {
            var $select = $(this);
            var type = $select.closest('.product-variant__select-container').data('type');
            var value = $select.val();
            if (type && value && value.trim() !== '') {
              selectedOptions[type] = value.replace('€', '').trim();
            }
          });
          
          // Try to find variant that matches all selected options
          var SelectedVariant = null;
          
          // First, try matching by all options together (best match)
          for (var i = 0; i < variants.length; i++) {
            var variant = variants[i];
            var matches = true;
            
            for (var optionType in selectedOptions) {
              var selectedValue = selectedOptions[optionType];
              var normalizedOption1 = (variant.option1 || '').replace('€', '').trim();
              var normalizedOption2 = (variant.option2 || '').replace('€', '').trim();
              var normalizedOption3 = (variant.option3 || '').replace('€', '').trim();
              
              // Check if selected value matches any of the variant options
              if (normalizedOption1 !== selectedValue && 
                  normalizedOption2 !== selectedValue && 
                  normalizedOption3 !== selectedValue) {
                matches = false;
                break;
              }
            }
            
            if (matches && Object.keys(selectedOptions).length > 0) {
              SelectedVariant = variant;
              break;
            }
          }
          
          // Fallback: if only one option is selected, match by that option
          if (!SelectedVariant) {
            var optionTypes = Object.keys(selectedOptions);
            if (optionTypes.length === 1) {
              var singleValue = selectedOptions[optionTypes[0]];
              for (var i = 0; i < variants.length; i++) {
                var variant = variants[i];
                var normalizedOption1 = (variant.option1 || '').replace('€', '').trim();
                if (normalizedOption1 === singleValue) {
                  SelectedVariant = variant;
                  break;
                }
              }
            }
          }
          
          // Update variant inputs if variant found
          if (SelectedVariant) {
            $('#variant-selected').val(SelectedVariant.id);
            $('#variant-id').val(SelectedVariant.id);
            $('.main-product-detail-buy input[name="id"]').val(SelectedVariant.id);
            
            // Always update price and button when variant changes
            updatePriceForVariant(SelectedVariant);
            updateAddToCartButton(SelectedVariant);
            
            console.log('[Variant] Updated to variant ID:', SelectedVariant.id, 'Price:', SelectedVariant.price);
          } else {
            console.log('[Variant] No matching variant found for selected options:', selectedOptions);
          }
        };
        
        // Universal handler that ALWAYS runs for all selects
        // This is the primary handler - it works for all variant types
        $('.product-variant__select').on('change', function() {
          userHasInteracted = true;
          generalSelectHandler();
        });
        
        // Initialize on page load if selects have values
        // Wait a bit to ensure DOM is fully ready
        setTimeout(function() {
          var hasAnySelection = false;
          $('.product-variant__select').each(function() {
            if ($(this).val() && $(this).val().trim() !== '') {
              hasAnySelection = true;
              return false; // break
            }
          });
          if (hasAnySelection) {
            generalSelectHandler();
          }
          
          // Initialize radio buttons if any are checked
          var checkedRadio = $('.product-variant__radio:checked, input[type=radio][name^="product-variant-"]:checked').first();
          if (checkedRadio.length > 0) {
            checkedRadio.trigger('change');
          }
        }, 200);
        
        // Also handle radio buttons (including new variant preview radio buttons)
        $(document).on('change', '.product-variant__radio, input[type=radio][name="product-variant"], input[type=radio][name^="product-variant-"]', function() {
          userHasInteracted = true;
          var selectedRadio = $(this);
          var selectedVariantId = selectedRadio.data('variant-id');
          var SelectedVariant = null;
          
          // If we have multiple option groups, collect all selected options
          var selectedOptions = {};
          $('.product-variant__radio:checked, input[type=radio][name^="product-variant-"]:checked').each(function() {
            var $radio = $(this);
            var optionName = $radio.data('option-name') || $radio.closest('.product-variant__select-container').data('type');
            var optionValue = $radio.val();
            if (optionName && optionValue) {
              selectedOptions[optionName] = optionValue.replace('€', '').trim();
            }
          });
          
          // Try to find variant by ID first (most reliable)
          if (selectedVariantId) {
            for (var i = 0; i < variants.length; i++) {
              if (variants[i].id == selectedVariantId) {
                SelectedVariant = variants[i];
                break;
              }
            }
          }
          
          // If multiple options are selected, try to match by all options
          if (!SelectedVariant && Object.keys(selectedOptions).length > 1) {
            for (var i = 0; i < variants.length; i++) {
              var variant = variants[i];
              var matches = true;
              
              for (var optionType in selectedOptions) {
                var selectedValue = selectedOptions[optionType];
                var normalizedOption1 = (variant.option1 || '').replace('€', '').trim();
                var normalizedOption2 = (variant.option2 || '').replace('€', '').trim();
                var normalizedOption3 = (variant.option3 || '').replace('€', '').trim();
                
                if (normalizedOption1 !== selectedValue && 
                    normalizedOption2 !== selectedValue && 
                    normalizedOption3 !== selectedValue) {
                  matches = false;
                  break;
                }
              }
              
              if (matches) {
                SelectedVariant = variant;
                break;
              }
            }
          }
          
          // Fallback: find by single option value
          if (!SelectedVariant) {
            var selectedValue = selectedRadio.val();
            for (var i = 0; i < variants.length; i++) {
              var variant = variants[i];
              var normalizedValue = (selectedValue || '').replace('€', '').trim();
              var normalizedOption1 = (variant.option1 || '').replace('€', '').trim();
              var normalizedOption2 = (variant.option2 || '').replace('€', '').trim();
              var normalizedOption3 = (variant.option3 || '').replace('€', '').trim();
              
              if (normalizedOption1 === normalizedValue || 
                  normalizedOption2 === normalizedValue || 
                  normalizedOption3 === normalizedValue) {
                SelectedVariant = variant;
                break;
              }
            }
          }
          
          if (SelectedVariant) {
            $('#variant-selected').val(SelectedVariant.id);
            $('#variant-id').val(SelectedVariant.id);
            $('.main-product-detail-buy input[name="id"]').val(SelectedVariant.id);
            
            // Update selected image if available
            var imageUrl = selectedRadio.data('image');
            if (imageUrl) {
              $('#selected-image').html('<img src="' + imageUrl + '" alt="' + SelectedVariant.title + '">');
            }
            
            // Update price and button
            updatePriceForVariant(SelectedVariant);
            updateAddToCartButton(SelectedVariant);
          }
        });
      }
    } else {
      // Handle sample products (product ID 87191644409230000000000)
      var variants = window.productVariants || [];
      if (variants.length > 0) {
        var selectedVariant = null;
        var SelectedVariantech;
  
        var hiddenInputValue = $('.main-product-detail-buy input[type="hidden"]').val();
        $('.main-product-detail-buy input[type="hidden"]').val('');
  
        /* MASQUE */
        $('div.product-variant__select-container.banzdodown[data-type="echantillons"] select.custom_echantillons_masque').change(function(){
          var selectedechElement = $(this);
          var SelectedVariantech;
          var echValue = selectedechElement.val() !== undefined ? selectedechElement.val() : null;
  
          var selectedOption = $(this).find('option:selected');
          var selectedId = selectedOption.data('id');
          var matches = selectedId.match(/\d+/g);
          var variantId = matches[matches.length - 1];
  
          $('.main-product-detail-buy.masque input[name="id"]').val(variantId);
        });
      }
    }
  }
  
  // Start initialization
  initVariantHandlers();
  
  // Sesami service functionality
  document.addEventListener("DOMContentLoaded", function(event) {
    var sesamiDateInput = document.querySelector("[name^='properties[date]']");
    if (!sesamiDateInput) {
      sesamiDateInput = document.querySelector("[name^='properties[Date]']");
    }
    if (sesamiDateInput) {
      sesamiDateInput.addEventListener("change", function() {
        setTimeout(function() {
          window.location.href = "/cart"
        }, 1500);
      });
    }
  });
  
  // NOTE: the mobile "sticky add-to-cart, revealed after passing the bundle block" logic
  // was removed — the add-to-cart button is now shown inline and always visible on mobile,
  // like on desktop (see bnz-product-page.css). No scroll/reveal handling is needed.

  // Gravure functionality - Form submission and character counter (only if block exists)
  // Check if gravure elements exist (block is present)
  const gravureInput = document.getElementById('gravure-input');
  
  // CRITICAL: If gravure block is not present, remove any orphaned gravure-form-input
  if (!gravureInput) {
    const productForm = document.getElementById('product-form');
    if (productForm) {
      const orphanedInput = document.getElementById('gravure-form-input');
      if (orphanedInput) {
        orphanedInput.remove();
        console.log('[Gravure] Removed orphaned gravure-form-input (block not present)');
      }
    }
  }
  
  if (gravureInput) {
    console.log('[Gravure] Setting up form handler and character counter');
    
    // Form submission handler
    function setupGravureFormHandler() {
    const productForm = document.getElementById('product-form');
    const gravureInput = document.getElementById('gravure-input');
    
    if (productForm && gravureInput) {
      // Handle form submission - update the existing input instead of creating new ones
      productForm.addEventListener('submit', function(e) {
        console.log('[Gravure] Form submit event triggered (from bnz-product-page.js)');
        const gravureFormInput = document.getElementById('gravure-form-input');
        
        if (gravureFormInput) {
          // Try to get from localStorage first, then validated text, then input value
          const gravureStorageKey = 'gravure_' + (window.productId || '');
          let gravureText = '';
          
          try {
            gravureText = localStorage.getItem(gravureStorageKey) || window.validatedGravureText || gravureInput.value.trim();
          } catch (e) {
            gravureText = window.validatedGravureText || gravureInput.value.trim();
          }
          
          console.log('[Gravure] Gravure text to set:', gravureText);
          gravureFormInput.value = gravureText || '';
          console.log('[Gravure] Updated gravure-form-input value to:', gravureFormInput.value);
        } else {
          console.error('[Gravure] gravure-form-input not found');
        }
      }, true); // Use capture phase
      
      // Also handle button clicks in case form is submitted differently - use capture phase
      const addToCartButtons = document.querySelectorAll('#AddToCart');
      addToCartButtons.forEach(function(button) {
        button.addEventListener('click', function(e) {
          console.log('[Gravure] Add to cart button clicked (from bnz-product-page.js)');
          const gravureFormInput = document.getElementById('gravure-form-input');
          
          if (gravureFormInput) {
            const gravureStorageKey = 'gravure_' + (window.productId || '');
            let gravureText = '';
            
            try {
              gravureText = localStorage.getItem(gravureStorageKey) || window.validatedGravureText || (gravureInput ? gravureInput.value.trim() : '');
            } catch (e) {
              gravureText = window.validatedGravureText || (gravureInput ? gravureInput.value.trim() : '');
            }
            
            gravureFormInput.value = gravureText || '';
            console.log('[Gravure] Updated gravure-form-input via button click:', gravureFormInput.value);
          }
        }, true); // Use capture phase to run before other handlers
      });
      
      console.log('[Gravure] Form submission handler attached');
    }
  }

  // Character counter
  function setupGravureCounter() {
    const gravureInput = document.getElementById('gravure-input');
    const gravureContainer = document.getElementById('gravure-input-container');
    
    if (gravureInput && gravureContainer) {
      const helpText = gravureContainer.querySelector('.gravure-help-text');
      const maxLength = gravureInput.getAttribute('maxlength') || 50;
      if (helpText) {
        gravureInput.addEventListener('input', function() {
          const currentLength = this.value.length;
          const maxLengthNum = parseInt(maxLength);
          helpText.textContent = 'Maximum ' + maxLengthNum + ' caractères (' + currentLength + '/' + maxLengthNum + ')';
        });
        console.log('[Gravure] Character counter attached');
      }
    }
  }

  // Try to setup form handler and counter
  let setupAttempts = 0;
  function trySetup() {
    setupAttempts++;
    const gravureInput = document.getElementById('gravure-input');
    const productForm = document.getElementById('product-form');
    
    console.log('[Gravure] Setup attempt', setupAttempts, '- Input found:', !!gravureInput, 'Form found:', !!productForm);
    
    if (gravureInput && productForm) {
      setupGravureFormHandler();
      setupGravureCounter();
      console.log('[Gravure] Setup complete');
    } else if (setupAttempts < 20) {
      setTimeout(trySetup, 200);
    }
  }

    // Start setup after a delay
    setTimeout(function() {
      console.log('[Gravure] Starting setup attempts');
      trySetup();
    }, 500);
  } // End of gravure input check